import React, { useState } from 'react';
import { FaCalendarCheck, FaTimes } from 'react-icons/fa';
import SelectPlanForm, { FORM_ID } from './SelectPlanForm';
import { formatPlanPriceWhole } from './planPricingUtils';
import './SpecialtyPlans.css';

export default function SelectPlanModal({ plan, onClose, onConfirm }) {
  const [footerState, setFooterState] = useState({
    canSubmit: false,
    estimatedPrice: null,
    choice: null,
    slotCount: 0,
  });

  if (!plan) return null;

  const slotLabel = footerState.slotCount === 1 ? '1 slot selected' : `${footerState.slotCount} slots selected`;

  return (
    <div className="sp-modal-overlay" role="presentation" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="sp-modal sp-modal--select-v2" role="dialog" aria-labelledby="sp-select-plan-title">
        <header className="sp-modal__header sp-modal__header--select-v2">
          <div className="sp-select-modal-title">
            <span className="sp-select-modal-title__icon" aria-hidden>
              <FaCalendarCheck />
            </span>
            <div>
              <h2 id="sp-select-plan-title">Select plan</h2>
              <p>{plan.name}</p>
            </div>
          </div>
          <button type="button" className="sp-modal__close" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </header>

        <div className="sp-modal__body sp-modal__body--select-v2">
          <SelectPlanForm
            plan={plan}
            onStateChange={setFooterState}
            onConfirm={(selection) => {
              onConfirm?.(selection);
              onClose();
            }}
          />
        </div>

        <footer className="sp-select-footer-v2">
          <div className="sp-select-footer-v2__summary">
            <span className="sp-select-footer-v2__meta">
              You pay
              {footerState.slotCount > 0 ? ` - ${slotLabel}` : ''}
            </span>
            <strong className="sp-select-footer-v2__total">
              {footerState.estimatedPrice != null
                ? formatPlanPriceWhole(footerState.estimatedPrice)
                : '-'}
            </strong>
          </div>
          <button
            type="submit"
            form={FORM_ID}
            className="btn-primary sp-select-footer-v2__cta"
            disabled={!footerState.canSubmit}
          >
            Continue ->
          </button>
        </footer>
      </div>
    </div>
  );
}
